module.exports = __webpack_public_path__ + "static/media/wwz.14aec1dd.jpg";